import * as React from "react";
function ClearIcon(props) {
    return React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", height: "1em", width: "1em", ...props },
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.5, d: "M19 19 5 5m14 .001L5 19z" }));
}
export default ClearIcon;
//# sourceMappingURL=Clear.js.map